<script>
	let weight = 200,
		feet = '5',
		inches = '10',
		bmi = (weight / Math.pow(parseInt(feet) * 12 + parseInt(inches), 2)) * 703,
		five = 0,
		seven = 0,
		hideTryMe = false,
		calculating = false,
		results = false,
        ref = null;
	const // code = `<div class="fvsvn-calc"></div>
		// <script type="module" src="https://"><\/script>`.replace(/\s\s+/g, ''),
		// hideEmbed = () => (hidden = true),
        refocus = () => ref.focus(),
		calc = () => {
			hideTryMe = true;
			if (!weight && weight !== 0) return;
			else {
				calculating = true;
				five = weight * 0.05;
				seven = weight * 0.07;
				bmi =
					(weight / Math.pow(parseInt(feet) * 12 + parseInt(inches), 2)) * 703;
				setTimeout(() => {
					calculating = false;
					results = true;
                    refocus();
				}, 1000);
			}
		},
		idSuffix = Math.abs(
			new Date().valueOf() ^ Math.floor(Math.random() * 1e9)
		).toString(36);
        

	(function (w, d, s, l, i) {
		w[l] = w[l] || [];
		w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
		var f = d.getElementsByTagName(s)[0],
			j = d.createElement(s),
			dl = l != 'niddkCalcDataLayer' ? '&l=' + l : '';
		j.async = true;
		j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
		f.parentNode.insertBefore(j, f);
	})(window, document, 'script', 'niddkCalcDataLayer', 'GTM-MFVCZSG');
</script>

<div
	role="region"
	aria-labelledby="fvsvn-title-{idSuffix}"
	class="fvsvn-calc-container"
>
	<span id="fvsvn-title-{idSuffix}" class="fvsvn-calc-header"
		>Diabetes Risk Management Calculator</span
	>
	{#if !results}
		<form class="fvsvn-calc-form" on:submit|preventDefault bind:this={ref}>
			<div class="fvsvn-body-text" tabindex="0">
				<p>
					Losing 5% to 7% of your body weight may reduce your risk of diabetes.<a
						id="footnote-label-{idSuffix}-ref"
						href="#footnote-label-{idSuffix}"
						aria-describedby="footnote-label-{idSuffix}"
						aria-label="footnote"><sup>†</sup></a
					>
				</p>
			</div>
			<div class="fvsvn-inputs">
				<div
					class={'fvsvn-input-container' +
						(calculating ? ' fvsvn-disabled' : '')}
				>
					<label for="fvsvn-feet-{idSuffix}"
						>Height<span class="fvsvn-sr-only"> in feet</span></label
					>
					<div class="fvsvn-input fvsvn-height">
						<select
							name="feet"
							id="fvsvn-feet-{idSuffix}"
							on:focus={() => (hideTryMe = true)}
							bind:value={feet}
						>
							{#each ['4', '5', '6', '7'] as foot}
								<option value={foot} selected={feet === foot}>{foot}</option>
							{/each}
						</select>
						<abbr title="feet" class="fvsvn-input-label">ft</abbr>

						<i class="fvsvn-dropdown" />
					</div>
					<div class="fvsvn-input fvsvn-height">
						<select
							name="inches"
							id="fvsvn-inches-{idSuffix}"
							on:focus={() => (hideTryMe = true)}
							bind:value={inches}
							aria-label="Height in inches"
						>
							{#each ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'] as inch}
								<option value={inch} selected={inches === inch}>{inch}</option>
							{/each}
						</select>
						<abbr title="inches" class="fvsvn-input-label">in</abbr>

						<i class="fvsvn-dropdown" />
					</div>
				</div>
				<div
					class={'fvsvn-input-container' +
						(calculating ? ' fvsvn-disabled' : '')}
				>
					<label for="fvsvn-weight-{idSuffix}"
						>Weight<span class="fvsvn-sr-only"> in pounds</span></label
					>
					<div class="fvsvn-input fvsvn-weight">
						<input
							tabindex="0"
							type="number"
							inputmode="numeric"
							name="weight"
							id="fvsvn-weight-{idSuffix}"
							class={weight || weight === 0 ? '' : 'fvsvn-error'}
							step={1}
							required
							on:focus={e => {
								e.target.select();
								hideTryMe = true;
							}}
							bind:value={weight}
							on:keydown={e =>
								['-', '.', 'e', 'E', '+'].includes(e.key) && e.preventDefault()}
						/>
						<abbr title="pounds" class="fvsvn-input-label" aria-hidden="true"
							>lbs</abbr
						>
					</div>
				</div>
			</div>

			<button
				class="fvsvn-button"
				tabIndex="0"
				on:click={() => calc()}
				type="submit"
			>
				{#if calculating}
					<span class="fvsvn-loading-spinner" aria-hidden="true" />
					Calculating...
				{:else}
					Calculate
				{/if}
				{#if !hideTryMe}
					<span class="fvsvn-try-me" aria-hidden="true">Try me</span>
				{/if}
			</button>
			<!-- Enable code below for shareable version of application -->
			<!-- <button
			tabindex="0"
			class="fvsvn-embed-link"
			on:click={() => {
				hidden = false;
			}}>Add calculator to your website</button
		> -->

			<div class="fvsvn-footnotes">
				<span aria-hidden="true">† </span>
				<span id="footnote-label-{idSuffix}">
					For adults 20 and older at high risk of developing type 2 diabetes
				</span>
				<a class="fvsvn-sr-only" href="#footnote-label-{idSuffix}-ref"
					>Back to content</a
				>
			</div>
		</form>
	{:else}
		<form class="fvsvn-calc-form" on:submit|preventDefault bind:this={ref}>
			<div class="fvsvn-body-metrics">
				<span class="fvsvn-metric" tabindex="0">Height {feet}'{inches}"</span>
				<span class="fvsvn-metric" tabindex="0">Weight {weight} lbs</span>
			</div>

			<div class="fvsvn-body-text fvsvn-results">
				{#if bmi <= 25}
					<p tabindex="0">
						Your height and weight combined could mean that losing weight may not
                        be needed to manage your diabetes risk.
					</p>
				{:else if bmi >= 40}
					<p tabindex="0">
						Your height and weight combined could mean that weight-loss treatment
                        from a health care professional may benefit your health and help
                        manage your diabetes risk.
					</p>
				{:else}
					<p class="fvsvn-valid" tabindex="0">
						Losing 5% to 7% of your weight, or
						<span class="fvsvn-weight-loss"
							>{Math.round(five)}<span class="fvsvn-sr-only"> to </span><span
								aria-hidden="true">-</span
							>{Math.round(seven)}<abbr
								title="pounds"
								class="fvsvn-units"
								aria-hidden="true">lbs</abbr
							></span
						>
						may help reduce diabetes risk.
					</p>
				{/if}
				<div class="fvsvn-disclaimer" tabindex="0">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						aria-hidden="true"
					>
						<g>
							<path fill="none" d="M0 0h24v24H0z" />
							<path
								d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z"
							/>
						</g>
					</svg>
					<p>Talk with your health professional about what options are best for you.</p>
				</div>
			</div>

			<div class="fvsvn-buttons">
				{#if bmi >= 25 && bmi <= 40}
					<a
						href="https://www.niddk.nih.gov/health-information/weight-management/adult-overweight-obesity"
						target="_blank"
						class="fvsvn-button"
						tabIndex="0"
					>
                        Next steps to manage weight
					</a>
                {:else if bmi < 25}
					<a
						href="https://www.niddk.nih.gov/health-information/diabetes/overview/risk-factors-type-2-diabetes"
						target="_blank"
						class="fvsvn-button"
						tabIndex="0"
					>
                        Learn more about diabetes risk
					</a>

                {:else}
                    <a
                        href="https://www.niddk.nih.gov/health-information/weight-management/adult-overweight-obesity/treatment"
                        target="_blank"
                        class="fvsvn-button"
                        tabIndex="0"
                    >
                        Learn about weight-loss treatments
                    </a>
				{/if}
				<button
					class="fvsvn-button fvsvn-reset"
					tabIndex="0"
					on:click={() => {
                        results = false;
                        refocus();
                    }}
					type="button"
				>
                    Try the calculator again
				</button>
			</div>
		</form>
	{/if}

	<div class="fvsvn-niddk-logo">
		<span
			>Supported by a
			<a
				href="https://www.niddk.nih.gov/about-niddk/research-areas/diabetes/diabetes-prevention-program-dpp"
				target="_blank">study</a
			>
			from</span
		>
		<!-- Add line below to svg for external embed launch -->
		<!-- hidden={/niddk\.(nih\.gov|dev)$/.test(location.hostname)} -->
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="-528 662 578 130"
			enable-background="new -528 662 578 130"
			xml:space="preserve"
			><title>NIH: NIDDK</title><g
				><g
					><path
						fill="#646569"
						d="M-383.6,698.1v58h-10.1l0,0v-26.3h-26.6v26.3h-10.1v-58h10.1v23.2h26.6v-23.2l0,0H-383.6z M-440.6,756.4 L-440.6,756.4h-10.1v-58h10.1V756.4z M-460.7,756.4L-460.7,756.4h-10.8l-26.6-42.8h-0.3v42.8h-9.8l0,0v-58l0,0h10.8l0,0l26.6,42.8 h0.3v-42.8h9.8V756.4z M-347.7,727l-35.9-65h-132.6c-6.7,0-11.9,5.4-11.9,11.9v106c0,6.7,5.4,11.9,11.9,11.9h132.3L-347.7,727z"
					/><path
						fill="#71963E"
						d="M-374.5,792l36.1-65l-35.9-65h9c4.9,0,10.8,3.6,13.2,7.7l31.5,57.3l-31.7,57.3c-2.3,4.4-8.3,7.7-13.4,7.7 H-374.5z"
					/></g
				><g fill="#616365"
					><path
						d="M-293.8,689.1h13.7l33.5,54.2h0.3v-54.2h12.4v73.8h-13.7l-33.5-54.2h-0.3v54.2h-12.4V689.1z"
					/>
					<path d="M-218.7,689.1h12.9v73.8h-12.9V689.1z" /><path
						d="M-190.1,689.1h30.7c5.7,0,10.6,1,14.7,2.8c4.1,1.8,7.5,4.6,10.1,8s4.6,7.2,5.9,11.6 c1.3,4.4,1.8,9.3,1.8,14.4s-0.5,9.8-1.8,14.4c-1.3,4.4-3.1,8.3-5.9,11.6c-2.6,3.4-5.9,5.9-10.1,8c-4.1,1.8-9,2.8-14.7,2.8h-30.4 v-73.8L-190.1,689.1L-190.1,689.1z M-177.2,752.3h12.6c4.9,0,9-0.8,12.4-2.1c3.1-1.3,5.7-3.1,7.5-5.7c1.8-2.3,3.1-5.2,3.6-8.3 c0.8-3.1,1-6.7,1-10.3c0-3.6-0.3-7.2-1-10.3s-1.8-5.9-3.6-8.3s-4.4-4.1-7.5-5.7c-3.1-1.3-7.2-2.1-12.4-2.1h-12.6V752.3z"
					/><path
						d="M-115.6,689.1h30.4c5.7,0,10.6,1,14.7,2.8c4.1,1.8,7.5,4.6,10.1,8s4.6,7.2,5.9,11.6s1.8,9.3,1.8,14.4 s-0.5,9.8-1.8,14.4c-1.3,4.4-3.1,8.3-5.9,11.6c-2.6,3.4-5.9,5.9-10.1,8c-4.1,1.8-9,2.8-14.7,2.8h-30.4V689.1z M-102.7,752.3H-90 c4.9,0,9-0.8,12.4-2.1c3.1-1.3,5.7-3.1,7.5-5.7c1.8-2.3,3.1-5.2,3.6-8.3c0.8-3.1,1-6.7,1-10.3c0-3.6-0.3-7.2-1-10.3 s-1.8-5.9-3.6-8.3c-1.8-2.3-4.4-4.1-7.5-5.7c-3.1-1.3-7.2-2.1-12.4-2.1h-12.6V752.3z"
					/>
					<path
						d="M-41,689.1h12.9v33.5l32.8-33.5h16l-29.4,29.4l31.5,44.4h-16l-24.2-35.1l-10.6,10.3v24.8H-41L-41,689.1 L-41,689.1z"
					/></g
				></g
			></svg
		>
	</div>

	<!-- Enable for shareable version of application -->
	<!-- <div class="fvsvn-modal" {hidden} on:click={hideEmbed}>
		<div role="dialog" class="fvsvn-modal-window" aria-labelledby="fvsvn-dialog-{idSuffix}" on:click|stopPropagation>
			<span class="fvsvn-calc-header" id="fvsvn-dialog-{idSuffix}">Copy the code below</span>
			<span tabindex="0" class="fvsvn-close" on:click={hideEmbed} />
			<p class="fvsvn-embed-desc">
				A widget is interactive content from NIDDK that displays directly on
				your web page. You can embed content in personalized home pages, blogs,
				and other sites. Once you've added the widget, there's no technical
				maintenance. NIDDK will update the content automatically.
			</p>
			<label for="fvsvn-embed-code-{idSuffix}"
				>Copy code to embed on other sites</label
			>
			<textarea
				id="fvsvn-embed-code-{idSuffix}"
				tabindex="0"
				rows="8"
				on:click={e => e.target.select()}>{code}</textarea
			>
			<button
				class="fvsvn-button"
				tabindex="0"
				type="button"
				on:click={hideEmbed}>Got it</button
			>
		</div>
	</div> -->
</div>

<style type="text/scss" global>
	@import './main.scss';
</style>
